import React, { memo } from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { useSelector } from "react-redux";
import { CommonLoaderBackdropSx } from "../../assets/styles/commonSx";

function PageLoader() {
  const isLoading = useSelector((store) => store.global.loading);

  return (
    <Backdrop sx={CommonLoaderBackdropSx} open={isLoading}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}

export default memo(PageLoader);
